import { render, staticRenderFns } from "./addEnroll.vue?vue&type=template&id=6e5808cd&"
import script from "./addEnroll.vue?vue&type=script&lang=js&"
export * from "./addEnroll.vue?vue&type=script&lang=js&"
import style0 from "./addEnroll.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports